import React, { useState } from "react";
import {
  ApiOutlined,
  GlobalOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import IntegrationSettings from "./components/IntegrationSettings";
import CareerPageSettings from "./components/CareerPageSettings";
import ATSScoringWeightsEditor from "./components/ATSScoringWeights";
import RecruitmentHeader from "../components/RecruitmentHeader";
import { Link } from "react-router-dom";

const menuItems = [
  { key: "career-page", icon: <GlobalOutlined />, label: "Career Page" },
  { key: "integrations", icon: <ApiOutlined />, label: "Integrations" },
  { key: "ats-scoring", icon: <BarChartOutlined />, label: "ATS Scoring" },
];

const RecruitmentSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState("career-page");

  const renderContent = () => {
    switch (activeTab) {
      case "integrations": return <IntegrationSettings />;
      case "career-page": return <CareerPageSettings />;
      case "ats-scoring": return <ATSScoringWeightsEditor />;
      default: return <IntegrationSettings />;
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <RecruitmentHeader title="Recruitment Settings" breadcrumb="Settings" />

        
        <div
          style={{
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            marginBottom: 20,
          }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              padding: "0 16px",
              borderBottom: "2px solid #f0f0f0",
              
            }}>
            {menuItems.map(({ key, icon, label }) => {
              const isActive = activeTab === key;
              return (
                <button
                  key={key}
                  onClick={() => setActiveTab(key)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 7,
                    padding: "14px 12px",
                    background: "transparent",
                    border: "none",
                    borderBottom: isActive
                      ? "2px solid #1677ff"
                      : "2px solid transparent",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    fontWeight: isActive ? 600 : 400,
                    fontSize: 14,
                    color: isActive ? "#1677ff" : "#595959",
                    transition: "all 0.2s",
                    marginBottom: -1, 
                  }}>
                  <span
                    style={{
                      fontSize: 15,
                      color: isActive ? "#1677ff" : "#8c8c8c",
                      display: "flex",
                      alignItems: "center",
                    }}>
                    {icon}
                  </span>
                  {label}
                </button>
              );
            })}
          </div>

          
          <div style={{ padding: 20 }}>{renderContent()}</div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2025 © CMS.</p>
        <p>
          Designed & Developed By{" "}
          <Link to="#" className="text-primary" onClick={(e: any) => e.preventDefault()}>
            ZYVO
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RecruitmentSettings;